export enum ExternalClient {
	KINDLE = "kindle",
	NIGHT_WATCH = "night-watch",
}

export interface Address {
	city: null | string;
	country: null | string;
	phone?: null | string;
	postalCode?: null | string;
	stateProvince: null | string;
	street1: null | string;
	street2?: string;
	zipCode?: string;
}

export interface BaseDocument {
	createdAt: Date;
	id: string;
	updatedAt: Date;
}

export interface BoundingBox {
	x1: number;
	x2: number;
	y1: number;
	y2: number;
}

export interface External {
	handle?: string;
	id: string;
	installation?: string;
	name: ExternalClient;
}

export interface GpsLocation {
	coordinates: [number, number];
	type: "Point";
}

export interface Image {
	altText?: string;
	height?: number;
	key?: string;
	src?: string;
	width?: number;
}

export type MapCoordinates = [number, number];

export type MediaType =
	| "audio/aac"
	| "audio/flac"
	| "audio/mp3"
	| "audio/mpeg"
	| "audio/ogg"
	| "audio/wav"
	| "text/html"
	| "text/markdown"
	| "text/plain"
	| "video/mkv"
	| "video/mp4";
